import(/* webpackMode: "eager" */ "/builds/sympla/comprador/discovery-next/src/app/favoritos/error.tsx");
